import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import * as actions from '../../../../redux/actions';
import LogRepairVehicle from './LogRepairVehicle';
import { Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import moment from 'moment';
import { REPAIR_STATUS } from 'config/constant/RepairStatus';
import { TYPE_REPAIR } from 'config/constant/TypeRepair';
import currencyFormatterTH from 'util/functions/currencyFormat';

const History = ({ repairDetail }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const repair_log = useSelector((state) => state.repair_log);
    const [repairLog, setRepairLog] = useState([]);

    useEffect(() => {
        dispatch(actions.repairLogAllVehicleById(repairDetail?.vehicle_id));
        return () => {};
    }, []);

    useEffect(() => {
        setRepairLog(repair_log?.arr);
        setIsLoading(true);
        return () => {};
    }, [repair_log]);

    console.log('repairDetail', repairDetail);

    console.log('repair_log', repair_log);

    const textColor = (data) => {
        if (data == REPAIR_STATUS[2]) {
            return <div className="font-bold text-green-600">{data}</div>;
        } else {
            return <div className="font-bold text-red-600 ">{data}</div>;
        }
    };

    const typeColor = (data) => {
        if (data === TYPE_REPAIR[0]) {
            return (
                <div className="font-medium text-sm text-center bg-blue-200 hover:bg-blue-300">
                    {data}
                </div>
            );
        } else if (data === TYPE_REPAIR[1]) {
            return (
                <div className="font-medium text-sm text-center bg-purple-200 hover:bg-purple-300">
                    {data}
                </div>
            );
        } else if (data === TYPE_REPAIR[2]) {
            return (
                <div className="font-medium text-sm text-center bg-green-200 hover:bg-green-300">
                    {data}
                </div>
            );
        }
    };

    const genRepairType = (data) => {
        return _.map(data, (_data) => (
            <div key={_data?.repair_type_id} className="pt-2">
                {_data?.repair_type?.repair_detail +
                    ' , ' +
                    'ราคา ' +
                    _data?.price +
                    ' บาท'}
            </div>
        ));
    };

    const genLogRepair = () => {
        return _.map(repair_log?.arr, (_log, index) => (
            <Tr key={_log?.repair_id}>
                <Td>{index + 1}</Td>
                <Td>{moment(_log?.createdAt).format('DD/MM/YYYY')}</Td>
                <Td>{moment(_log?.updatedAt).format('DD/MM/YYYY')}</Td>
                <Td>
                    {_log?.mileage?.mileage == null ? (
                        <div> - </div>
                    ) : (
                        <>
                            {currencyFormatterTH.format(_log?.mileage?.mileage)}
                        </>
                    )}
                </Td>
                <Td>{_log?.data?.detail}</Td>
                <Td>{genRepairType(_log?.problem_logs)}</Td>
                <Td>{textColor(_log?.repair_status)}</Td>
            </Tr>
        ));
    };

    if (isLoading)
        return (
            <div className="p-4 pr-4">
                <label className="block uppercase text-gray-700 text-sm font-bold mb-2">
                    ประวัติการซ่อม ทะเบียน :{' '}
                    {repairDetail?.vehicle?.serial_number}
                </label>

                <div className="overflow-y-auto max-h-48 ">
                    <Table className="bg-white " size="sm">
                        <colgroup>
                            <col width="5%" />
                            <col width="15%" />
                            <col width="15%" />
                            <col width="10%" />
                            <col width="15%" />
                            <col width="30%" />
                            <col width="10%" />
                        </colgroup>
                        <Thead>
                            <Tr>
                                <Th>ลำดับ</Th>
                                <Th>วันที่แจ้งซ่อม</Th>
                                <Th>วันที่ซ่อมสำเร็จ</Th>
                                <Th>เลขไมล์</Th>
                                <Th>ประเภทการแจ้งซ่อม</Th>
                                <Th>รายละเอียดการซ่อม</Th>
                                <Th>สถานะ</Th>
                            </Tr>
                        </Thead>
                        <Tbody className="text-center">{genLogRepair()}</Tbody>
                    </Table>
                </div>
            </div>
        );
    else {
        return <></>;
    }
};

export default History;
